import { dateToStoreISO, storeWallTimeToIso } from './timezones';

// Ola 3 (Cortes): ¿el día de HOY de la tienda ya quedó cubierto por algún corte no anulado?
// "Hoy" es el día local de la TIENDA (nunca el del dispositivo) y un corte lo cubre si su fin cae
// dentro de hoy o después del inicio del día (los turnos nocturnos terminan de madrugada).
export function isTodayCovered(
  closes: Array<{ endAt: string; status: string }>,
  now: Date,
  timeZone: string,
): boolean {
  const todayIso = dateToStoreISO(now, timeZone);
  const dayStart = Date.parse(storeWallTimeToIso(`${todayIso}T00:00`, timeZone));
  return closes.some((close) => close.status !== 'VOIDED' && Date.parse(close.endAt) >= dayStart);
}
